import React from 'react';
import './style.scss';

export default function Banner({
    title,
    classname,
    text = null,
    link = null,
    image
}) {
    const imageBasePath = 'https://fiverr-res.cloudinary.com/w_iw_div_2.0,q_100,f_auto/general_assets/pro_experience/assets/images/f1/';
    const style = {
        backgroundImage: `url(${imageBasePath}${image})`
    };

    return (
        <section className="wide-banner">
            <div className={`wide-banner-wrapper ${classname}`} style={style}>
                <i className="fiverr-pro-logo"/>
                <h3>{title}</h3>
                {text && <p>{text}</p>}
                {link && <a href={link.href} target="_blank">{link.title}</a>}
            </div>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/common/HomePage/Banner/index.js